import Page from '@modules/forgotpassword/pages/default';

export default Page;
